<template>
  <div
    v-if="visibleItems.length > 0"
    class="tw:flex tw:mx-auto tw:flex-col tw:w-full tw:md:max-w-screen-lg tw:lg:max-w-screen-xl tw:pb-6"
  >
    <p class="tw:text-2xl tw:font-bold tw:mb-8" data-testid="hotel-offers-past-offers-section">
      {{ $t('hotel_offers_past_header') }}
    </p>
    <ul class="tw:shadow tw:rounded-xl tw:mb-8">
      <PastOfferItem
        v-for="offer in visibleItems"
        :pastOffer="offer"
        :key="`${offer.createdAt}_${offer.publishingDate}`"
      />
    </ul>
    <button v-if="hasMoreItems" class="tw:flex tw:mb-6 tw:text-sm tw:text-blue-700 tw:font-bold" @click="loadMore">
      {{ $t('hotel_offers_show') }}
    </button>
  </div>
</template>
<script setup>
import { computed, ref } from 'vue'

import PastOfferItem from '@/components/hotelOffers/PastOfferItem.vue'

const props = defineProps({
  pastOffers: {
    type: Array,
    default: () => [],
    required: true,
  },
  hasActiveOffer: {
    type: Boolean,
    default: false,
  },
})

const itemsToShow = ref(6)

const sortedOffers = computed(() => {
  const sorted = [...props.pastOffers].sort((a, b) => {
    const dateA = new Date(a.publishingDate)
    const dateB = new Date(b.publishingDate)

    if (isNaN(dateA.getTime())) return 1
    if (isNaN(dateB.getTime())) return -1

    return dateB - dateA
  })
  return props.hasActiveOffer ? sorted.slice(1) : sorted
})

const visibleItems = computed(() => {
  return sortedOffers.value.slice(0, itemsToShow.value)
})

const hasMoreItems = computed(() => {
  return itemsToShow.value < sortedOffers.value.length
})

const loadMore = () => {
  itemsToShow.value += 6
}
</script>
